import { render, staticRenderFns } from "./TradeFlowPage.vue?vue&type=template&id=8f41f1ba&"
import script from "./TradeFlowPage.vue?vue&type=script&lang=js&"
export * from "./TradeFlowPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports